import { getWebEnv } from '../env.js';

const API_URL = getWebEnv().apiUrl;

/**
 * Create a Stripe payment intent for seller onboarding
 */
export async function createPaymentIntent(onboardingId) {
  const response = await fetch(`${API_URL}/api/payments/create-intent`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ onboardingId }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Failed to create payment intent' }));
    throw new Error(error.error || 'Failed to create payment intent');
  }

  return response.json();
}

/**
 * Get payment status for an onboarding
 */
export async function getPaymentStatus(onboardingId) {
  const response = await fetch(`${API_URL}/api/payments/status/${onboardingId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Failed to get payment status' }));
    throw new Error(error.error || 'Failed to get payment status');
  }

  return response.json();
}
